import * as React from 'react';

function SvgApplePayColour(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 56 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="ApplePayColour_svg__a"
        maskUnits="userSpaceOnUse"
        x={15}
        y={8}
        width={24}
        height={12}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.89 8.963h22.976v11.033H15.89V8.963z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#ApplePayColour_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.708 11.872l1.413 3.62c.079.206.152.413.22.622.07.212.132.408.186.586h.023l.185-.575c.07-.212.147-.431.232-.656l1.32-3.597h.58l-1.61 4.085c-.148.395-.3.787-.458 1.178-.13.324-.275.641-.434.951-.133.26-.282.51-.447.75-.144.21-.313.4-.503.568a2.734 2.734 0 01-.597.423 5.158 5.158 0 01-.365.168l-.185-.452a4.6 4.6 0 00.463-.244c.182-.11.349-.242.498-.394.14-.14.292-.323.458-.552a3.88 3.88 0 00.446-.83.937.937 0 00.07-.243.7.7 0 00-.07-.244l-2.004-5.164h.58zm-1.61 2.588a7.476 7.476 0 00-.92.035c-.32.03-.616.099-.886.203a1.69 1.69 0 00-.672.458c-.177.202-.266.469-.266.801 0 .395.112.685.336.87.223.186.474.279.752.279.224 0 .425-.03.603-.093a1.567 1.567 0 00.793-.603c.09-.132.157-.267.203-.407.039-.154.058-.267.058-.336V14.46zm.546 1.66c0 .224.003.449.011.673.008.224.03.44.07.65h-.51l-.081-.79h-.024a2.097 2.097 0 01-.642.62c-.143.09-.305.162-.487.216a2.091 2.091 0 01-.596.081c-.27 0-.508-.044-.713-.133a1.465 1.465 0 01-.504-.348c-.13-.142-.23-.31-.295-.494a1.66 1.66 0 01-.098-.557c0-.657.276-1.164.828-1.52.552-.356 1.384-.526 2.496-.51v-.151c0-.147-.013-.316-.04-.505a1.586 1.586 0 00-.18-.54 1.163 1.163 0 00-.417-.429c-.185-.116-.436-.174-.753-.174-.24 0-.476.037-.712.11-.236.073-.45.176-.643.307l-.174-.406c.247-.17.503-.292.765-.365.268-.074.544-.111.822-.11.386 0 .7.066.944.197.244.132.435.302.574.51.14.212.237.451.284.703.05.254.074.512.075.771v2.194zm-8.037-2.507c.131.039.278.066.44.081.162.016.336.023.521.023.695 0 1.234-.162 1.616-.487.382-.325.573-.8.573-1.427 0-.302-.05-.565-.15-.79a1.412 1.412 0 00-.429-.55 1.952 1.952 0 00-.66-.326 3.052 3.052 0 00-.846-.11c-.247 0-.46.01-.637.029-.177.02-.32.04-.428.064v3.493zm-.545-3.9c.246-.04.494-.076.742-.104a7.86 7.86 0 01.892-.046c.463 0 .862.056 1.198.168.337.112.612.273.828.482.188.188.335.413.435.661.104.255.156.55.156.882 0 .403-.071.755-.214 1.056a2.187 2.187 0 01-.585.76 2.46 2.46 0 01-.88.459c-.34.1-.71.15-1.113.15a4.36 4.36 0 01-.914-.08v3.341h-.545V9.714zm-4.375.623c.302-.363.506-.87.45-1.373-.436.017-.963.288-1.275.652-.28.321-.525.836-.46 1.33.487.037.983-.245 1.285-.609zm1.09 3.196c.011 1.302 1.148 1.735 1.16 1.74-.009.031-.18.618-.598 1.224-.36.524-.735 1.046-1.325 1.056-.58.011-.766-.34-1.429-.34s-.87.33-1.418.351c-.57.021-1.003-.567-1.367-1.089-.744-1.068-1.312-3.017-.549-4.333.38-.653 1.056-1.067 1.792-1.078.559-.01 1.087.374 1.428.374.342 0 .983-.462 1.658-.394.282.012 1.074.113 1.583.853-.041.025-.946.548-.936 1.636z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export default SvgApplePayColour;
